export default {
  title01: "Current weather",
  title02: "24 hours",
  title03: "10-day forecast",
  title04: "AQI",
  title05: "All info",
  title06: "SUNRISE AND SUNSET",
  title07: "PHASE OF THE MOON",
  title08: "Next full moon",
  title09: "Next new moon",
  title10: "DAY",
  title11: "NIGHT",
  title12: "Sunrise",
  title13: "Sunset",
  title14: "Moonrise",
  title15: "Moonset",
  title16: "Source",
  title17: "Start",
  title18: "End",
  title19: "Use Current Location",
  title20: "Search the city",
  title21: "Feels like",
  title22: "Feels like (shade)",
  title23: "Now",
  title24: "Today",
  title25: "Sun",
  title26: "Mon",
  title27: "Tue",
  title28: "Wed",
  title29: "Thu",
  title30: "Fri",
  title31: "Sat",
  title32: "Loading...",
  title33: "Now",
  title34: "Hourly",
  title35: "Daily",
  title36: "Sun & Moon",
  title37: "Air quality",
  title38: "Contact to : xlf550402@gmail.com",
  title39: "Privacy Agreement",
  title40: "Copyright © comfortweather.com 2020 - 2025. All Right Reserved.",
  title41: "Data provided by",
  title42: "Hi",
  title43: "Lo",
  title44: "Accept",
  title45: "Thank you for using ComfortWeather! To better protect your legal rights and interests, please read the ",
  title46: "Privacy Policy",
  title47: " carefully before use.",
  title48: "",
  title49: "Contact to : xyjph123@gmail.com",
  title50: "Copyright © 24hweather.com 2020 - 2025. All Right Reserved.",
  title51: "Thank you for using 24hweather! To better protect your legal rights and interests, please read the ",
};
